/**
 * DEPLETIONS-INVENTORY MODULE
 * Self-contained. Import only from /shared or within this module.
 * Do not import from other modules directly.
 */

// Public entry point for the depletions-inventory module. The app composition root imports
// ONLY from here; nothing deep-imports this module's internals.
import Depletions from "./routes/Depletions.jsx";
import Inventory from "./routes/Inventory.jsx";
import { getDashboardSummary } from "./utils/dashboardSummary.js";

export const depletionsInventoryRoutes = [
  { path: "/depletions", component: Depletions },
  { path: "/inventory", component: Inventory },
];

// Listed on the support ticket form's "Area" dropdown (collected automatically).
export const moduleMeta = { key: "depletions-inventory", label: "Depletions & Inventory" };

// Operations-hub (Home) contribution — Days of Supply + Depletions YTD KPIs and
// a low-stock signal. Collected automatically by the composition root.
export const dashboardProvider = getDashboardSummary;
